import { TableFilterType } from 'features/TableFilter';

interface ZonesListFilters {
  warehouseId?: string;
  zoneType?: string;
  isActive?: boolean;
}

export const transformZonesListFilters = ({ selectedWarehouseId, zoneType, availability }: TableFilterType): ZonesListFilters => {
  return {
    warehouseId: selectedWarehouseId?.value || undefined,
    zoneType: zoneType?.value || undefined,
    isActive: availability?.value === undefined ? undefined : availability.value === 'available',
  };
};
